import React, { useContext, useState } from "react";
import style from "./index.module.scss";
import { Button, Dropdown, Input, Menu, Radio, Spin } from "antd";
import UploadButton from "./Components/UploadButton";
import {
    downloadErrFile,
    findLog,
    downloadGradePdf,
    downloadGradeExcel,
    PublishStatus,
    GradeShowType,
    saveDcGradeTypeSet
} from "../../../../../../service/score";
import useRequestFn from "utils/useRequestFn";
import { errorMessage } from "service/service";
import { ResultMessage } from "components/ResultMessage";
import useModalHandler from "utils/useModalHandler";
import ResultModal from "components/ResultModal";
import Help from "../Help";
import useBatchNo from "../../../../../../utils/useBatchNo";
import ScoreBaseContext from "../../../context";
import { RadioChangeEvent } from "antd/lib/radio";
import Config from "../../../../../../config";
import { MenuExport } from "./Components/MenuExport";

interface ToolsProps {
    keyword: string; //关键字
    setKeyword: (val: string) => void;
    setPageNo: (no: number) => void; //修改页码
    courseNo: string;
    courseSeq: string;
    refreshData: () => void; //刷新成绩单
    hasCustom: boolean; //是否有自定义项
    status: PublishStatus | null; //成绩单状态
}

const Index = ({
    keyword,
    setKeyword,
    setPageNo,
    courseSeq,
    courseNo,
    refreshData,
    hasCustom,
    status
}: ToolsProps) => {
    const [text, setText] = useState(keyword);
    const [getData, { data, loading }] = useRequestFn(findLog);
    const [downloadGradePdfFn, statePdf] = useRequestFn(downloadGradePdf);
    const [downloadGradeExcelFn, stateExcel] = useRequestFn(downloadGradeExcel);

    const resultModal = useModalHandler();

    //获取导入结果状态
    const getImportResult = async () => {
        try {
            await getData(courseNo, courseSeq);
            resultModal.open();
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    };

    //下载
    const download = async (filePath?: string) => {
        if (!filePath) return;
        try {
            await downloadErrFile(filePath);
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    };

    //回传关键词，并设置当前页码为1
    const handleSearch = () => {
        setKeyword(text);
        setPageNo(1);
    };

    const { batchNo } = useBatchNo();

    const menu = (
        <Menu>
            <Menu.Item>
                <Button
                    type="link"
                    loading={statePdf.loading}
                    onClick={() => downloadGradePdfFn(courseNo, courseSeq)}>
                    PDF格式
                </Button>
            </Menu.Item>
            <Menu.Item>
                <Button
                    type="link"
                    loading={stateExcel.loading}
                    onClick={() => downloadGradeExcelFn(courseNo, courseSeq)}>
                    Excel格式
                </Button>
            </Menu.Item>
        </Menu>
    );

    const { Operator, ShowType, ReloadShowType, ShowTypeLoading } =
        useContext(ScoreBaseContext);

    const [setType, { loading: setLoading }] = useRequestFn(saveDcGradeTypeSet);
    async function onTypeChange(e: RadioChangeEvent) {
        await setType({
            batchNo,
            config: e.target.value,
            courseNo,
            courseSeq,
            customerCode: Config.CustomCode
        });
        await ReloadShowType();
        await refreshData();
    }

    return (
        <div className={style.root}>
            <div className={style.flex}>
                <Input
                    className={style.input}
                    value={text}
                    onChange={e => setText(e.target.value)}
                    placeholder="请输入要搜索学生的姓名或学号"
                    onPressEnter={handleSearch}
                />
                <Button
                    className={style.search}
                    type="primary"
                    onClick={handleSearch}>
                    查询
                </Button>
                <Help />
            </div>

            <div className={style.flex}>
                <span className={style.types}>成绩类型:</span>
                <Spin spinning={setLoading || ShowTypeLoading}>
                    <Radio.Group
                        value={ShowType}
                        buttonStyle="solid"
                        size="small"
                        onChange={onTypeChange}>
                        <Radio.Button value={GradeShowType.percentage}>
                            百分制
                        </Radio.Button>
                        <Radio.Button value={GradeShowType.number}>
                            折算后
                        </Radio.Button>
                    </Radio.Group>
                </Spin>

                <Button type="link" onClick={getImportResult}>
                    查看导入结果
                </Button>

                {/*有自定义项且成绩单未发布才显示导入按钮*/}
                {Operator?.importEx && (
                    <UploadButton
                        courseNo={courseNo}
                        courseSeq={courseSeq}
                        refreshData={refreshData}
                        handelResultVisible={getImportResult}
                    />
                )}

                <Dropdown overlay={menu} placement="bottomLeft">
                    <Button type="primary" ghost>
                        下载成绩单
                    </Button>
                </Dropdown>

                <MenuExport
                    courseNo={courseNo}
                    courseSeq={courseSeq}
                    text={text}
                />
            </div>

            {resultModal.render(
                <ResultModal
                    data={data || []}
                    loading={loading}
                    visible={resultModal.visible}
                    onCancel={resultModal.close}
                    download={download}
                    alertMessage={
                        "Excel 导入成绩单任务仍在继续，若Excel 导入成绩单失败"
                    }
                />
            )}
        </div>
    );
};

export default Index;
